const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
const isMobile = viewportWidth < 768;

const Config = {
    chartHeight: isMobile ? 320 : 400,
    margin: 10,
    pieChartMargin: isMobile ? 90 : 20,
    animationBegin: 500,
    animationDuration: 1250,
    animationEasing: 'ease-in-out',
};

export default Config;
